/* eslint-disable */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import "./ReportingDashboard.css"; // Reusing existing styling
import { Select, MenuItem, FormControl, InputLabel, ListItemText, Checkbox, Input } from '@material-ui/core';

const iconBasePath = "/images/";

// 🔹 Reusing icons logic or defining new ones if needed
const reportIcons = {
    "default": iconBasePath + "IC_energy management.svg",
    // Add specific mappings if names match existing ones or new icons are provided
};

class BRSRStructure extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            reports: [],
            error: '',
            reportingCards: [], // For drilldown list
            isModalOpen: false,
            selectedReportingCards: [],
            currentStandardCard: null,
            viewMode: 'list', // 'list' or 'drilldown'
            drilldownCards: [],
            cardSelections: {} // To store dropdown selections per card: { [standardCardId]: [selectedIds] }
        };
    }

    componentDidMount() {
        this.fetchStructure();
        this.fetchReportingCards();
    }

    fetchStructure = () => {
        this.setState({ loading: true, error: '' });

        axios.get(`${config.laravelBaseUrl}brsr/standard-master-structure`, {
            headers: {
                authorization: "Bearer " + sessionStorage.getItem("userToken"),
            },
        })
            .then((res) => {
                const data = res.data?.data || res.data || [];
                if (Array.isArray(data)) {
                    // 🔹 Parse saved selections
                    const initialSelections = {};
                    data.forEach(item => {
                        if (item.selected_reporting_cards) {
                            try {
                                const selections = item.selected_reporting_cards.split(',')
                                    .map(id => parseInt(id, 10))
                                    .filter(n => !isNaN(n));
                                if (selections.length > 0) {
                                    initialSelections[item.id] = selections;
                                }
                            } catch (e) {
                                console.error("Error parsing saved selections", e);
                            }
                        }
                    });

                    this.setState({
                        reports: data,
                        cardSelections: initialSelections
                    });
                } else {
                    this.setState({ reports: [], error: 'Invalid data format received.' });
                }
            })
            .catch((error) => {
                console.error("Error fetching BRSR structure:", error);
                this.setState({ error: "Failed to fetch BRSR structure." });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    fetchReportingCards = () => {
        // Fetch list of available Reporting Dashboard cards for drilldown
        axios.get(`${config.laravelBaseUrl}brsr/cards`, {
            headers: {
                authorization: "Bearer " + sessionStorage.getItem("userToken"),
            },
        })
            .then((res) => {
                const data = res.data?.data || res.data || [];
                if (Array.isArray(data)) {
                    this.setState({ reportingCards: data });
                }
            })
            .catch((err) => console.error("Error fetching reporting cards:", err));
    };

    truncateParams = (params, limit = 2) => {
        if (!params) return "—";
        if (typeof params === 'string') {
            return params.length > 100 ? params.substring(0, 100) + "..." : params;
        }
        if (Array.isArray(params)) {
            if (params.length === 0) return "—";
            if (params.length <= limit) return params.join(", ");
            const visible = params.slice(0, limit).join(", ");
            return `${visible} ...`;
        }
        return params;
    };

    // --- Drilldown Logic ---

    // Updated: Auto-save on change
    handleSelectionChange = (event, standardCardId) => {
        const { value } = event.target; // Value is an array of IDs

        this.setState(prevState => ({
            cardSelections: {
                ...prevState.cardSelections,
                [standardCardId]: value
            }
        }), () => {
            this.saveSelection(standardCardId, value);
        });
    };

    // New: Save to Backend
    saveSelection = (standardCardId, selectedIds) => {
        axios.post(`${config.laravelBaseUrl}brsr/standard-master/update-cards`, {
            structure_id: standardCardId,
            selected_cards: selectedIds
        }, {
            headers: {
                authorization: "Bearer " + sessionStorage.getItem("userToken"),
            }
        })
            .then(res => {
                console.log("Selection saved successfully");
            })
            .catch(err => {
                console.error("Failed to save selection:", err);
                // Optional: Show toast or ignore
            });
    };

    isNarrativeFlag = (flags) => {
        return Array.isArray(flags) && flags.includes("narrative");
    };

    renderDrilldownView = () => {
        const { drilldownCards, currentStandardCard } = this.state;

        return (
            <div className="w-100">
                {/* Header / Back Button */}
                <div className="d-flex align-items-center mb-4 justify-content-between">
                    <div className="d-flex align-items-center">
                        <button className="btn btn-light shadow-sm mr-3 rounded-circle" onClick={this.handleBackToStructure} style={{ width: '35px', height: '35px' }}>
                            <i className="fas fa-arrow-left text-secondary" style={{ fontSize: '0.9rem' }}></i>
                        </button>
                        <div>
                            <h6 className="mb-0 font-weight-bold text-dark" style={{ fontSize: '1.1rem' }}>
                                {currentStandardCard?.standard_card_name}
                            </h6>
                            <small className="text-muted" style={{ fontSize: '0.8rem' }}>Drill-down view of selected reports</small>
                        </div>
                    </div>
                </div>

                {/* 📦 Grid Layout for Cards */}
                <div className="row">
                    {drilldownCards.map((report, index) => (
                        <div key={report.id} className="col-12 col-md-6 col-xl-4 mb-4">

                            {/* 📄 Report Card */}
                            <div className="card report-card h-100 border-0 shadow-sm hover-scale transition-all" style={{
                                borderRadius: '10px',
                                overflow: 'hidden',
                                transition: 'transform 0.2s',
                                fontSize: '0.9rem'
                            }}>
                                {/* Colored Top Bar */}
                                <div style={{ height: '4px', background: 'linear-gradient(90deg, #4e73df 0%, #224abe 100%)' }}></div>

                                <div className="card-body p-3 d-flex flex-column">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div className="d-flex align-items-center">
                                            <div className="icon-circle bg-primary text-white mr-2" style={{ width: '32px', height: '32px' }}>
                                                <img
                                                    src={reportIcons[report.name] || reportIcons["default"]}
                                                    alt=""
                                                    style={{ maxWidth: '16px', filter: 'brightness(0) invert(1)' }}
                                                />
                                            </div>
                                            <div>
                                                <h6 className="font-weight-bold text-dark mb-0" style={{ fontSize: '1rem' }} title={report.name}>
                                                    {report.name.length > 50 ? report.name.substring(0, 50) + '...' : report.name}
                                                </h6>
                                                <span className="badge badge-pill badge-light border px-2 py-0" style={{ fontSize: '0.7rem' }}>Active</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row text-muted small mb-3 flex-grow-1">
                                        <div className="col-12 mb-1">
                                            <strong>Desc:</strong> {report.card_description || "—"}
                                        </div>
                                        <div className="col-12 mb-1">
                                            <strong>Params:</strong> {this.truncateParams(report.parameters, 5)}
                                        </div>
                                        <div className="col-6 mb-1">
                                            <strong>Units:</strong> {
                                                Array.isArray(report.operating_units) ?
                                                    (report.operating_units.length > 1 ? `${report.operating_units[0]} +${report.operating_units.length - 1}` : report.operating_units.join(", "))
                                                    : "—"
                                            }
                                        </div>
                                        <div className="col-6 mb-1">
                                            <strong>Ref:</strong> {report.reference || "—"}
                                        </div>
                                    </div>

                                    <div className="mt-auto">
                                        <hr className="my-2" />
                                        <div className="d-flex justify-content-between align-items-center">
                                            {/* Left side actions */}
                                            <div>
                                                <Link
                                                    to={`/reporting/details/${report.id}`}
                                                    className="btn btn-light btn-sm mr-1 text-primary font-weight-bold py-0"
                                                    style={{ fontSize: '0.8rem' }}
                                                    title="View Details"
                                                >
                                                    <i className="fas fa-info-circle"></i>
                                                </Link>
                                            </div>

                                            {/* Right side actions */}
                                            <div className="d-flex">
                                                {/* Logic Gated Buttons */}
                                                {this.isNarrativeFlag(report.data_flag) ? (
                                                    <button className="btn btn-outline-secondary btn-sm mr-1 py-0 px-2" disabled style={{ fontSize: '0.8rem' }} title="Analysis"><i className="fas fa-chart-line"></i></button>
                                                ) : (
                                                    <Link to={`/reporting/analysis/${report.id}`} className="btn btn-outline-primary btn-sm mr-1 py-0 px-2" style={{ fontSize: '0.8rem' }} title="Analysis"><i className="fas fa-chart-line"></i></Link>
                                                )}

                                                {this.isNarrativeFlag(report.data_flag) ? (
                                                    <button className="btn btn-outline-secondary btn-sm mr-1 py-0 px-2" disabled style={{ fontSize: '0.8rem' }} title="Compute"><i className="fas fa-cogs"></i></button>
                                                ) : (
                                                    <Link to={`/reporting/computation/${report.id}`} className="btn btn-outline-warning btn-sm mr-1 py-0 px-2" style={{ fontSize: '0.8rem' }} title="Compute"><i className="fas fa-cogs"></i></Link>
                                                )}

                                                <Link to={`/reporting/generation/${report.id}`} className="btn btn-success btn-sm shadow-sm py-0 px-2" style={{ fontSize: '0.8rem' }} title="Generate Report">
                                                    Gen <i className="fas fa-arrow-right ml-1"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    handleDrillDown = (standardCard) => {
        const selectedIds = this.state.cardSelections[standardCard.id] || [];
        const { reportingCards } = this.state;

        const cardsToView = reportingCards.filter(c => selectedIds.includes(c.id));

        this.setState({
            viewMode: 'drilldown',
            drilldownCards: cardsToView,
            currentStandardCard: standardCard
        });
    };

    handleBackToStructure = () => {
        this.setState({
            viewMode: 'list',
            drilldownCards: [],
            currentStandardCard: null,
            selectedReportingCards: []
        });
    };

    renderReportCards = () => {
        const { reports, loading, error, reportingCards, cardSelections } = this.state;

        if (loading) {
            return (
                <div className="text-center mt-5 w-100">
                    <div className="spinner-border text-primary" role="status"></div>
                    <p className="mt-2 text-muted">Loading structure...</p>
                </div>
            );
        }

        if (error) {
            return (
                <div className="alert alert-danger text-center shadow-sm w-100">
                    {error}
                </div>
            );
        }

        if (!reports.length) {
            return (
                <div className="alert alert-light text-center shadow-sm w-100">
                    No structure data available.
                </div>
            );
        }

        return reports.map((report) => {
            const isDrillDown = String(report.drilldown_flag) === '1' || report.drilldown_flag === true;
            const currentSelection = cardSelections[report.id] || [];

            return (
                <div key={report.id} className="col-12 col-sm-6 col-md-4 col-lg-4 mb-4">
                    <div className="card report-card h-100 border-success shadow-sm">
                        <div className="card-header d-flex justify-content-between align-items-center bg-light">
                            <h6 className="mb-0 d-flex align-items-center text-truncate" title={report.standard_card_name}>
                                <div className="icon-circle text-white mr-2">
                                    <div className="icon-circle">
                                        <img
                                            src={reportIcons["default"]}
                                            alt=""
                                            className="report-header-icon"
                                        />
                                    </div>
                                </div>
                                {report.standard_card_name}
                            </h6>
                        </div>

                        <div className="card-body small">
                            <p>
                                <strong>Description:</strong>{" "}
                                {report.standard_card_description || "—"}
                            </p>

                            <div className="mb-3">
                                {isDrillDown ? (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <strong style={{ fontSize: '0.85rem', color: '#555' }}>Select Parameters</strong>
                                        </div>
                                        <FormControl className="w-100" style={{ margin: 0 }}>
                                            <Select
                                                multiple
                                                displayEmpty
                                                value={currentSelection}
                                                onChange={(e) => this.handleSelectionChange(e, report.id)}
                                                input={<Input disableUnderline style={{
                                                    fontSize: '0.85rem',
                                                    padding: '5px 10px',
                                                    height: '35px',
                                                    background: '#f8f9fa',
                                                    border: '1px solid #e3e6f0',
                                                    borderRadius: '5px'
                                                }} />}
                                                MenuProps={{
                                                    getContentAnchorEl: null,
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    transformOrigin: {
                                                        vertical: "top",
                                                        horizontal: "left",
                                                    },
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                            width: 250,
                                                            marginTop: '5px'
                                                        },
                                                    },
                                                }}
                                                renderValue={(selected) => {
                                                    if (selected.length === 0) return <em style={{ fontSize: '0.85rem', color: '#888' }}>Choose parameters...</em>;
                                                    // Map selected IDs to Names
                                                    const selectedNames = reportingCards
                                                        .filter(c => selected.includes(c.id))
                                                        .map(c => c.name);
                                                    return <span style={{ fontSize: '0.85rem', color: '#333' }}>{selectedNames.join(", ")}</span>;
                                                }}
                                                style={{ width: '100%' }}
                                            >
                                                {reportingCards.map((card) => (
                                                    <MenuItem key={card.id} value={card.id} style={{ fontSize: '0.85rem' }}>
                                                        <Checkbox checked={currentSelection.indexOf(card.id) > -1} color="primary" size="small" style={{ padding: '4px' }} />
                                                        <ListItemText primary={card.name} primaryTypographyProps={{ style: { fontSize: '0.85rem' } }} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </>
                                ) : (
                                    <>
                                        <strong>Parameters:</strong>
                                        <span className="ml-2 small text-muted">
                                            {this.truncateParams(report.standard_card_parameters)}
                                        </span>
                                    </>
                                )}
                            </div>

                            <p className="mb-1">
                                <strong>Reporting Boundary:</strong>{" "}
                                {report.standard_card_reporting_boundary || "—"}
                            </p>

                            <p className="mb-0">
                                <strong>Reference:</strong>{" "}
                                {report.card_brsr_reference || "—"}
                            </p>
                        </div>

                        {/* Footer - Only Drill Down Action */}
                        <div className="card-footer bg-white border-top-0 pt-0 pb-3">
                            {isDrillDown ? (
                                <button
                                    className={`btn btn-block ${currentSelection.length > 0 ? 'btn-primary' : 'btn-light text-muted'}`}
                                    onClick={() => this.handleDrillDown(report)}
                                    disabled={currentSelection.length === 0}
                                    style={{
                                        borderRadius: '6px',
                                        fontWeight: '600',
                                        transition: 'all 0.2s',
                                        boxShadow: currentSelection.length > 0 ? '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)' : 'none'
                                    }}
                                >
                                    <i className="fas fa-layer-group mr-2"></i>
                                    {currentSelection.length > 0 ? "Drill Down" : "Select to Drill Down"}
                                </button>
                            ) : (
                                <button className="btn btn-light btn-block btn-sm disabled" disabled>
                                    <i className="fas fa-lock mr-1"></i> Locked
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            );
        });
    };





    render() {
        return (
            <>
                <DashboardHeader />

                <div id="wrapper">
                    <DashboardSidebar />

                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <ol className="breadcrumb dashbread">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item">Reporting</li>
                                <li className="breadcrumb-item active">BRSR Structure</li>
                            </ol>

                            <div className="container-fluid container-dashboard">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <p className="heading mb-0">BRSR Structure Directory</p>
                                    {this.state.viewMode === 'list' && (
                                        <button className="btn btn-primary refresh-btn" onClick={this.fetchStructure}>
                                            <i className="fas fa-sync-alt"></i> Refresh
                                        </button>
                                    )}
                                </div>

                                <div className="row report-cards-container mb-5">
                                    {this.state.viewMode === 'drilldown' ? this.renderDrilldownView() : this.renderReportCards()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterComponent />
            </>
        );
    }
}

export default BRSRStructure;
